import React from "react";
import moment from "moment";
import Pagination from "react-js-pagination";

import { Skeleton } from "components";
import { PendHistory } from "types";

import HistoryFieldChanges from "./historyFieldChanges";

import styles from "../pend.module.scss";

type HistoryPendProps = {
	loading: boolean;
	history: Array<PendHistory>;
	count: number;
	page: number;
	handleHistoryPageChange: (page: number) => void;
};

const PAGE_SIZE = 50;

const HistoryPend = ({
	loading,
	history,
	count,
	page,
	handleHistoryPageChange,
}: HistoryPendProps) => {
	const Loader = ({ skeleton, component }) => {
		return loading ? skeleton() : component();
	};

	return (
		<Loader
			skeleton={() => <Skeleton height="6rem" marginTop="1.5rem" />}
			component={() =>
				history.length > 0 ? (
					<>
						<div className={styles.historyContent}>
							<h2 className={styles.historyTitle}>
								Pend history
							</h2>
							<ul className={styles.historyList}>
								{history.map(
									(item: PendHistory, index: number) => {
										const {
											changedBy: { firstName, lastName },
											created,
											fieldChanges,
										} = item;
										return (
											<li key={index}>
												<hgroup
													className={
														styles.historyHeadingGroup
													}
												>
													<h6>
														{firstName} {lastName}
													</h6>
													<h6>
														From &nbsp;
														<span className="pr-5">
															{moment
																.utc(created)
																.local()
																.format(
																	"DD MMMM YYYY",
																)}
														</span>
														<span className="pl-1">
															{moment
																.utc(created)
																.local()
																.format(
																	"h:mm a",
																)}
														</span>
													</h6>
												</hgroup>
												<HistoryFieldChanges
													fieldChanges={fieldChanges}
												/>
											</li>
										);
									},
								)}
							</ul>
						</div>
						<div className={styles.paginationContent}>
							<Pagination
								hideFirstLastPages
								prevPageText="〈 PREV"
								nextPageText="NEXT  〉"
								activePage={page + 1}
								itemsCountPerPage={PAGE_SIZE}
								totalItemsCount={count}
								pageRangeDisplayed={1}
								onChange={handleHistoryPageChange}
							/>
						</div>
					</>
				) : null
			}
		/>
	);
};

export default HistoryPend;
